export const SortOptions = {
    DEFAULT: 'Standard',
    TITLE_ASC: 'Titel (A-Z)',
    TITLE_DESC: 'Titel (Z-A)',
    PUB_DATE_ASC: 'Ausgestellt am (älteste zuerst)',
    PUB_DATE_DESC: 'Ausgestellt am (neueste zuerst)',
    DATE_ADDED_ASC: 'Hinzugefügt am (älteste zuerst)',
    DATE_ADDED_DESC: 'Hinzugefügt am (neueste zuerst)',
  };